"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var earn_activity_header_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/earn/earn-activity-header"));
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var constants_1 = require("../../config/constants");
var actions_1 = require("../../redux/reducers/activity/actions");
var actions_2 = require("../../redux/reducers/app/actions");
var useActivityDetailsData_1 = require("../../shared/hooks/providers/useActivityDetailsData");
var useScrollToTop_1 = require("../../shared/hooks/useScrollToTop");
var framework_1 = require("../../widgets/framework");
var styles_1 = __importDefault(require("./styles"));
var ViewUrlScreen = function (_a) {
    var _b, _c;
    var classes = _a.classes, t = _a.t, identifier = _a.identifier, earnActivityLinkIconName = _a.earnActivityLinkIconName;
    var _d = (0, react_1.useState)(false), activityComplete = _d[0], setActivityCompleted = _d[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var theme = (0, core_1.useTheme)();
    var activityId = identifier + '';
    var _e = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }), isLoggedIn = _e.isAuthenticated, authenticating = _e.authenticating, isRestricted = _e.isRestricted;
    var navigateToActivities = (0, react_1.useCallback)(function (message) {
        var appNavigate = {
            action: 'ACTIVITIES',
            data: message
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    }, []);
    var showInvalidError = (0, react_1.useCallback)(function () {
        navigateToActivities({
            message: t('activities.activityUnavailable'),
            type: 'warning',
            messageTimeout: 3000
        });
    }, [navigateToActivities, t]);
    var _f = (0, useActivityDetailsData_1.useActivityDetailsData)(activityId, isLoggedIn, showInvalidError), activity = _f.activity, initData = _f.initData;
    (0, useScrollToTop_1.useScrollToTop)();
    var redirectToLogin = function () {
        framework_1.GoFwInternalInstance.onHostLogin();
    };
    var redirectContactUs = function () {
        var appNavigate = {
            action: 'CONTACT_US'
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    };
    var onViewUrl = function () {
        if (!isLoggedIn) {
            redirectToLogin();
            return;
        }
        if (activity === null || activity === void 0 ? void 0 : activity.externalLink) {
            window.open(activity === null || activity === void 0 ? void 0 : activity.externalLink);
            dispatch((0, actions_1.credit)(activity.key, function () {
                initData();
                setActivityCompleted(true);
            }, function (e) {
                var _a, _b;
                dispatch((0, actions_2.showMessageBar)({
                    type: 'error',
                    message: ((_b = (_a = e === null || e === void 0 ? void 0 : e.payload) === null || _a === void 0 ? void 0 : _a.detail) === null || _b === void 0 ? void 0 : _b.includes('invalidAccess'))
                        ? t('error.activity.invalidAccess')
                        : t('error.general'),
                    messageTimeout: 10000
                }));
            }));
        }
    };
    var onDismissEarnPointsModal = function () {
        var _a;
        framework_1.GoFwInternalInstance.onEarnActivity();
        if ((_a = activity === null || activity === void 0 ? void 0 : activity.frequencyCap) === null || _a === void 0 ? void 0 : _a.limitReached) {
            navigateToActivities();
        }
        else {
            setActivityCompleted(false);
        }
    };
    if (!activity) {
        return null;
    }
    return (react_1.default.createElement("div", { className: classes.container },
        activityComplete && (react_1.default.createElement(package_1.EarnPointsModal, { pointEarned: activity.amount + ((_b = activity.bonusAmount) !== null && _b !== void 0 ? _b : 0), isVisible: activityComplete, onClose: onDismissEarnPointsModal })),
        react_1.default.createElement(core_1.Grid, { className: classes.container, container: true, spacing: 2 },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(earn_activity_header_1.default, { data: {
                        image: activity.imageUrl,
                        title: activity.title,
                        description: activity.description,
                        points: activity.amount,
                        preview_url: activity.videoUrl ? activity.videoUrl : undefined,
                        isCoverImage: true
                    }, hideBackBtn: true, bonusPoints: activity.bonusAmount ? activity.bonusAmount + activity.amount : 0, limitReached: isLoggedIn && !!((_c = activity === null || activity === void 0 ? void 0 : activity.frequencyCap) === null || _c === void 0 ? void 0 : _c.limitReached), onPress: onViewUrl, navigateTo: navigateToActivities, buttonText: 'View', buttonLabel: 'Link opens in a new browser tab', buttonLabelIcon: earnActivityLinkIconName !== null && earnActivityLinkIconName !== void 0 ? earnActivityLinkIconName : 'open_in_new', isRestricted: isLoggedIn && isRestricted, handleContactUs: redirectContactUs, showSignInWarning: !isLoggedIn && constants_1.RemoteConstants.getBoolean('SHOW_SIGN_IN_WARNING'), redirectToLogin: redirectToLogin })))));
};
exports.default = (0, react_i18next_1.withTranslation)()((0, core_1.withStyles)(styles_1.default)(ViewUrlScreen));
//# sourceMappingURL=index.js.map